interface TextBadgeProps {
    children: React.ReactNode;
    className?: string;
    textClassName?: string;
}

export const TextBadge = ({ children, className = '', textClassName = 'text-white/60' }: TextBadgeProps) => {
    return (
        <div className={`px-4 py-2 bg-gradient-to-br from-white/20 to-white/5 rounded-3xl 
            shadow-[0px_0.96px_23.96px_0px_rgba(69,42,124,0.10)] 
            border-2 border-white/10 
            backdrop-blur-xl inline-flex justify-start items-start gap-24 ${className}`}>
            <div className={`justify-start text-base font-normal font-outfit leading-6 text-center w-full ${textClassName}`}>
                {children}
            </div>
        </div>
    );
};